function o(e) {
  "@babel/helpers - typeof";
  return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, o(e);
}
function f(e, r) {
  if (o(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(e, r || "default");
    if (o(s) != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function a(e) {
  var r = f(e, "string");
  return o(r) == "symbol" ? r : r + "";
}
function u(e, r, t) {
  return (r = a(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var c = (e, r) => {
  e(...r);
}, l = class n {
  constructor() {
    u(this, "subscribers", /* @__PURE__ */ new Map());
  }
  getSubscribers(r) {
    const t = this.subscribers.get(r);
    if (t) return t;
    const s = [];
    return this.subscribers.set(r, s), s;
  }
  static getInstance() {
    return n.instance || (n.instance = new n()), n.instance;
  }
  on(r, t) {
    return this.getSubscribers(r).push(t), () => this.off(r, t);
  }
  once(r, t) {
    const s = ((...i) => {
      this.off(r, s), c(t, i);
    });
    return this.on(r, s);
  }
  off(r, t) {
    const s = this.getSubscribers(r);
    if (!t) {
      this.subscribers.set(r, []);
      return;
    }
    const i = s.indexOf(t);
    i !== -1 && s.splice(i, 1);
  }
  emit(r, ...t) {
    const s = [...this.getSubscribers(r)];
    for (const i of s) try {
      c(i, t);
    } catch (b) {
      console.error(`Error in event handler for "${String(r)}":`, b);
    }
  }
  clear() {
    this.subscribers.clear();
  }
};
u(l, "instance", void 0);
export {
  u as n,
  l as t
};

//# sourceMappingURL=events-BhpKDDpP.js.map